import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FiltersIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.32 9.42V7.58H12.52C12.94 6.28 14.18 5.3 15.62 5.3C17.38 5.3 18.86 6.78 18.86 8.5C18.86 10.22 17.38 11.7 15.62 11.7C14.18 11.7 12.94 10.72 12.52 9.42H5.32ZM15.62 9.92C16.38 9.92 17.02 9.26 17.02 8.5C17.02 7.74 16.38 7.08 15.62 7.08C14.86 7.08 14.22 7.74 14.22 8.5C14.22 9.26 14.86 9.92 15.62 9.92ZM8.38 18.62C6.62 18.62 5.14 17.14 5.14 15.42C5.14 13.7 6.62 12.22 8.38 12.22C9.82 12.22 11.06 13.2 11.48 14.5H18.68V16.34H11.48C11.06 17.64 9.82 18.62 8.38 18.62ZM8.38 16.84C9.14 16.84 9.78 16.18 9.78 15.42C9.78 14.66 9.14 14 8.38 14C7.62 14 6.98 14.66 6.98 15.42C6.98 16.18 7.62 16.84 8.38 16.84Z" />
    </SvgIcon>
  );
});
